import { Logger } from "aws-amplify";
import * as StorageUtils from "./storageUtils";
import { APP_USER_SESSION } from "../constant/AppConstants";
import { apiLogout, login } from "../services/auth.service";
import toast from "react-hot-toast";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const logger = new Logger("openidUtils");

export const setTokenExpired = (token, expiry, authTime) => {
  let userSession = StorageUtils.getParsedValue(APP_USER_SESSION);

  if (userSession === undefined) {
    userSession = {};
  }

  // reset the user
  userSession.user = null;
  userSession.state = null;
  userSession.role = null;
  userSession.token = {
    value: token,
    expiry: expiry,
    authTime: authTime,
  };

  logger.debug("set token expiration details ", userSession);
  StorageUtils.setValue(APP_USER_SESSION, userSession);
};

export const setUserInSession = async (
  username = null,
  id = null,
  email = null,
  state = null,
  setRole,
  setFlag
) => {
  let userSession = StorageUtils.getParsedValue(APP_USER_SESSION);
  if (userSession === undefined) {
    userSession = {};
  }
  userSession.user = {
    username,
    id,
    email,
  };
  userSession.state = state;
  userSession.role = null;
  logger.debug("setting user in session ", userSession);

  StorageUtils.setValue(APP_USER_SESSION, userSession);

  try {
    // const isFinanceAuthenticated = await gw2Login();
    // if (isFinanceAuthenticated) {
    //   const isAdminAuthenticated = await login();
    //   if (isAdminAuthenticated) {
    //     setFlag(true);
    //     setRole(true);
    //   }
    // }
    const promises = [login()];
    await Promise.all(promises);
    setFlag(true);
  } catch (error) {
    if (error?.response?.status !== 401) {
      toast.custom(
        <Dialog open>
          <DialogTitle>Request failed</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Oops, something went wrong. Please try again later.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={apiLogout}>Cancel</Button>
          </DialogActions>
        </Dialog>,
        {
          duration: Infinity,
        }
      );
    }
  }
};

export const setSessionState = (state) => {
  let userSession = StorageUtils.getParsedValue(APP_USER_SESSION);
  userSession.state = state;
  logger.debug("setting session state", userSession);

  StorageUtils.setValue(APP_USER_SESSION, userSession);
};

export const clearSessionState = () => {
  logger.debug("clearing session state");
  StorageUtils.deleteKey(APP_USER_SESSION);
};

export const logout = () => {
  try {
    const userSession = StorageUtils.getParsedValue(APP_USER_SESSION);
    const mcpLoginUrl = process.env.REACT_APP_GW3_MCP_LOGIN_URL;
    StorageUtils.clearStorage();

    const urlRequest =
      mcpLoginUrl + `/logout?access_token=${userSession.token.value}`;
    window.location.href = urlRequest;
  } catch (error) {
    logger.error("An error has occurred during sign out: ", error);
  }
};

export const tokenIsNotExpired = () => {
  let userSession = StorageUtils.getParsedValue(APP_USER_SESSION);
  let exp;
  let authTime;
  try {
    exp = userSession.token.expiry;
    authTime = userSession.token.authTime;
  } catch (err) {
    return false;
  }

  const currentSeconds = Math.floor(new Date().valueOf() / 1000);
  return currentSeconds > authTime && currentSeconds < exp;
};

export const hasScope = (scope, userRole, role = "View") => {
  if (Array.isArray(scope)) {
    return scope.some(s => hasScope(s, userRole, role));
  }

  if (scope && !userRole?.[scope]?.includes(role)) return false;

  return true
}